
import { SPEEDTEST_SERVERS } from "UTILS/Constants";

export default class SpeedTestHelper {
  constructor() {
    this.speedTestTimeout = null;
  }

  getSpeedTestResults(data) {
    const { dlStatus, ulStatus } = data;
    if (dlStatus === "Fail" || ulStatus === "Fail") {
      return {
        result: -1,
        download: dlStatus === "Fail" ? dlStatus : (Math.floor(dlStatus * 10) / 10).toFixed(1),
        upload: ulStatus === "Fail" ? ulStatus : (Math.floor(ulStatus * 10) / 10).toFixed(1),
      };
    }
    const lowerStatus = Math.min(dlStatus, ulStatus);
    let result;
    if (lowerStatus > 10) {
      result = 3;
    } else if (lowerStatus > 2) {
      result = 2;
    } else if (lowerStatus > 1) {
      result = 1;
    } else {
      result = 0;
    }
    return {
      result,
      download: (Math.floor(dlStatus * 10) / 10).toFixed(1),
      upload: (Math.floor(ulStatus * 10) / 10).toFixed(1),
    }
  }

  startSpeedTest(onComplete, onServerError, onTimeoutError) {
    if (typeof this.speedTestTimeout === "number") {
      clearTimeout(this.speedTestTimeout);
      this.speedTestTimeout = null;
    }
    this.speedtestInstance = new Speedtest();
    this.speedtestInstance.setParameter("time_dl_max", window._env_.SPEED_TEST_TIME_DL_MAX);  // Maximum download test time (sec)
    this.speedtestInstance.setParameter("time_ul_max", window._env_.SPEED_TEST_TIME_UL_MAX);   // Minimum upload test time (sec)
    this.speedtestInstance.setParameter("enable_quirks", false);
    this.speedtestInstance.setParameter("garbagePhp_chunkSize", window._env_.SPEED_TEST_GARBAGEPHP_CHUNKSIZE);
    this.speedtestInstance.setParameter("xhr_ul_blob_megabytes", window._env_.SPEED_TEST_XHR_UL_BLOB_MEGABYTES);
    this.speedtestInstance.setParameter("xhr_dlMultistream", window._env_.SPEED_TEST_XHR_DLMULTISTREAM);
    this.speedtestInstance.setParameter("xhr_ulMultistream", window._env_.SPEED_TEST_XHR_ULMULTISTREAM);
    this.speedtestInstance.setParameter("test_order", "UD");
    this.speedtestInstance.addTestPoints(SPEEDTEST_SERVERS);
    this.speedtestInstance.selectServer((server) => {
      if (server != null) {
        console.log("server", server);
        this.speedtestInstance.onupdate = (data) => {
          if (data.testState === 4) {
            if (typeof this.speedTestTimeout === "number") {
              clearTimeout(this.speedTestTimeout);
              this.speedTestTimeout = null;
            }
            onComplete(this.getSpeedTestResults(data));
          }
        };

        // Set a timer for the speed test timeout.
        this.speedTestTimeout = setTimeout(() => {
          this.speedtestInstance.abort();
          onTimeoutError();
        }, window._env_.SPEED_TEST_TIMEOUT_MSEC);

        // Start speed test
        this.speedtestInstance.start();
      } else {
        onServerError();
      }
    });
  }

  clear() {
    if (typeof this.speedTestTimeout === "number") {
      clearTimeout(this.speedTestTimeout);
      this.speedTestTimeout = null;
    }
    if (this.speedtestInstance && this.speedtestInstance.getState() === 3) {
      this.speedtestInstance.abort();
    }
  }
}